import { FC, ReactNode, memo } from 'react';
import { Button } from 'antd';
import { CloseOutlined, ReloadOutlined } from '@ant-design/icons';
import styles from './style.module.css';

interface Props {
  onReset: () => void;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  resetDisabled?: boolean;
}

const RightFilterPanelComponent: FC<Props> = ({
  onReset,
  onClose,
  children,
  title = 'Фильтры',
  resetDisabled = false,
}: Props) => {
  return (
    <aside className={styles.filterPanel}>
      <div className={styles.filterPanelHeader}>
        <h3 className={styles.filterPanelTitle}>{title}</h3>
        <div className={styles.filterPanelActions}>
          <Button
            type="text"
            icon={<ReloadOutlined />}
            onClick={onReset}
            disabled={resetDisabled}
            className={styles.resetButton}
          >
            Сброс
          </Button>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            className={styles.closeButton}
          />
        </div>
      </div>

      {children}
    </aside>
  );
};

export const RightFilterPanel = memo(RightFilterPanelComponent);
RightFilterPanel.displayName = 'RightFilterPanel';
